export default function Field({ label, children }) {
  return (
    <div className="space-y-1.5">
      <label className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</label>
      {children}
    </div>
  );
}
